/* import __COLOCATED_TEMPLATE__ from './device-code-vertical.hbs.js'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import DevicesSendDeviceCodeModal from '@dashboard/shared-ui/components/devices/send-device-code-modal';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { copy as copyToClipboard } from '@dashboard/shared-ui/utils/clipboard';

/**
  ## DevicesDeviceCodeVertical

   The redesigned sheet for showing device codes for verticals.

  ### Parameters
  * @param {String} password - the device code that we split into passwordChunks for readability
  * @param {Action} sendDeviceCode - action to call when user attempts to send device code
  * @param {Array<Employee>} employees - collection of employees. passed to send-device-code-modal
  * @param {String} sendCodeDescription - description for send code modal
  * @param {hash} headerImg - vertical specific header image
  * @param {hash} jewel - vertical specific jewel
  * @param {String} installAppTitle - step title for installing the vertical app
  * @param {String} installAppDescription - step description for installing the vertical app
  * @param {String} signInDescription - step description for signing into the vertical app
  * @param {String | undefined} headerTitle
  * @param {String | undefined} headerDescription
  *
*/
let DeviceCodeVertical = (_dec = computed('password'), _dec2 = computed('headerTitle'), _dec3 = computed('headerDescription'), _class = class DeviceCodeVertical extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "modal", _descriptor, this);
    _initializerDefineProperty(this, "flash", _descriptor2, this);
    _initializerDefineProperty(this, "i18n", _descriptor3, this);
  }
  /**
   * Splits password into chunks of 4
   * @returns {Array<String>}
   */
  get passwordChunks() {
    return this.password.match(/.{4}/g);
  }
  get title() {
    return this.headerTitle ?? this.i18n.t('sharedUi.devices.deviceCode.header.title');
  }
  get description() {
    return this.headerDescription ?? this.i18n.t('sharedUi.devices.deviceCode.header.description');
  }
  openSendDeviceCodeModal() {
    this.modal.open(DevicesSendDeviceCodeModal, {
      sendDeviceCode: this.sendDeviceCode,
      description: this.sendCodeDescription,
      employees: this.employees
    });
  }
  copyPassword() {
    copyToClipboard(this.element.querySelector('input.device-code-vertical__password-input')).then(() => {
      this.flash.sheetSuccess(this.i18n.t('sharedUi.devices.deviceCode.stepTwo.copySuccess'));
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "flash", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "passwordChunks", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "passwordChunks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "title", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openSendDeviceCodeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openSendDeviceCodeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyPassword", [action], Object.getOwnPropertyDescriptor(_class.prototype, "copyPassword"), _class.prototype), _class);
export { DeviceCodeVertical as default };